import { render, staticRenderFns } from "./content-model.vue?vue&type=template&id=b021fc10&scoped=true"
import script from "./content-model.vue?vue&type=script&lang=js"
export * from "./content-model.vue?vue&type=script&lang=js"
import style0 from "./content-model.vue?vue&type=style&index=0&id=b021fc10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b021fc10",
  null
  
)

export default component.exports